import $ from 'jquery'

$(document).ready(function() {
  co_vc_choose_stage()
})

function co_vc_choose_stage() {
  $('.co_vc_choose_stage').each(function() {})
}
